import { render, staticRenderFns } from "./ReceiptInterface.vue?vue&type=template&id=5ab80407&"
import script from "./ReceiptInterface.vue?vue&type=script&lang=js&"
export * from "./ReceiptInterface.vue?vue&type=script&lang=js&"
import style0 from "./ReceiptInterface.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports